(function () {
  window.addEventListener('click', (e) => {
    if (!e.target.matches("header, header *")) {
      document.querySelectorAll("header-animate").forEach((el) => {
        //set attribute true to other elements but not this
        el.dataset.action = "close";
      })
    }
  });
})();

function getFocusableElements(container) {
  if (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  if (elements) {
    var first = elements[0];
    var last = elements[elements.length - 1];
  }

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.classList.add('hidden');
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.classList.remove('hidden');
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not(.tw-btn-filters)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
    this.querySelector('.close-header-drawer')?.firstElementChild.addEventListener('click', this.onCloseButtonClick.bind(this));
    this.querySelector('.close-header-drawer')?.firstElementChild.addEventListener('click', this.bodyOverflowHidden.bind(this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }
    else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }



  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details:not(.mobile-facets__details--no-close)').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
    //this.bodyOverflowHidden();
  }

  bodyOverflowHidden() {
    const bodyOverflow = document.querySelector('body');
    bodyOverflow.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);

    // const utilityBar = document.querySelector('.utility-bar');
    // utilityBar.style.display = "block";
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

//custom element to close menu drawer with another custom button (not summary)
class ButtonCloseDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", (e) => {
      this.closest(".mobile-facets__disclosure").querySelector(".mobile-facets__close").click();
    })
  }
}

customElements.define('button-drawer-close', ButtonCloseDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');


    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalOpenerTabs extends ModalOpener {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      const dataTabId = this.dataset.tabSelected;
      const tabSelected = modal.querySelector(`toggle-tabs #${dataTabId}`);

      // Using tab-selected attribute, open a corresponding tab with the same id
      if (dataTabId && tabSelected) {
        publish(PUB_SUB_EVENTS.switchTab, tabSelected);
      }

      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener-tabs', ModalOpenerTabs);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class DeferredMediaCustom extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent(focus = true) {
    const self = this;
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      this.querySelector('template').content.querySelectorAll('video, model-viewer, iframe').forEach(function (element) {
        content.append(element.cloneNode(true));
      })

      this.setAttribute('loaded', true);
      content.querySelectorAll('video, model-viewer, iframe').forEach(function (element) {
        self.append(element);
        if (focus) element.focus();
        if (element.nodeName == 'VIDEO' && element.getAttribute('autoplay')) {
          // force autoplay for safari
          element.play();
        }
      });
    }
  }
}

customElements.define('deferred-media-custom', DeferredMediaCustom);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    // this.prevButton = this.querySelector('button[name="previous"]');
    // this.nextButton = this.querySelector('button[name="next"]');
    this.laptopQuery = window.matchMedia("(min-width: 1024px)").matches;

    if (this.laptopQuery == true) {
      this.verticalSlider = true;
    }
    else {
      this.classList.toggle('vertical-slider');
      this.verticalSlider = false;
    }
    this.resizeHandler();

    this.slider.addEventListener('scroll', this.update.bind(this));

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    // this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    // this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  resizeHandler() {
    window.addEventListener('resize', () => {
      let laptopQuery = window.matchMedia("(min-width: 1024px)").matches;
      if (laptopQuery == true) {
        this.verticalSlider = true;
        if (!this.classList.contains('vertical-slider')) {
          this.classList.toggle('vertical-slider');
        }
      }
      else {
        this.classList.toggle('vertical-slider');
        this.verticalSlider = false;
      }
    });
  }

  static get observedAttributes() {
    return ['data-reset'];
  }

  /*
   * Currently used in pdp. The sliders are updated when the variant changes
   * The browser will call this method for each change to the attributes listed in the observedAttributes array.
  */
  attributeChangedCallback(name, oldValue, newValue) {
    //console.log(`Attribute ${name} has changed from ${oldValue} to ${newValue}.`);
    if (oldValue == "false") {
      this.resetPages();
      this.setSlidePosition(0);

      this.setAttribute('data-reset', "false");
    }

  }

  initPages() {
    if (this.verticalSlider == false) {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
    }
    else {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
    }

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();

  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;

    const previousPage = this.currentPage;
    if (this.verticalSlider == false) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }
    else {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    this.dispatchEvent(
      new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      })
    );

    // When the slider is updated, the "is-active" class is removed and added to the visible "large" slide
    this.sliderItemsToShow.forEach(function (element) {
      element.classList.remove('is-active');
    });
    this.sliderItemsToShow[this.currentPage - 1]?.classList.add('is-active');

    // if (this.enableSliderLooping) return;

    // if (this.verticalSlider == false) {
    //   if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
    //     this.prevButton.setAttribute('disabled', 'disabled');
    //   } else {
    //     this.prevButton.removeAttribute('disabled');
    //   }

    //   if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
    //     this.nextButton.setAttribute('disabled', 'disabled');
    //   }
    //   else {
    //     this.nextButton.removeAttribute('disabled');
    //   }

    //   if (this.currentPage == this.totalPages) {
    //     this.nextButton.setAttribute('disabled', 'disabled');
    //   }
    // }
    // else {
    //   if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
    //     this.prevButton.setAttribute('disabled', 'disabled');
    //   } else {
    //     this.prevButton.removeAttribute('disabled');
    //   }

    //   if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
    //     this.nextButton.setAttribute('disabled', 'disabled');
    //   } else {
    //     this.nextButton.removeAttribute('disabled');
    //   }

    //   if (this.currentPage == this.totalPages) {
    //     this.nextButton.setAttribute('disabled', 'disabled');
    //   }
    // }

  }

  isSlideVisible(element, offset = 0) {
    if (this.verticalSlider == false) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
    else {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.verticalSlider == false) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    }
    else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    }
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.verticalSlider == false) {
      this.slider.scrollTo({
        left: position,
      });
    }
    else {
      this.slider.scrollTo({
        top: position,
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      // [this.prevButton, this.nextButton].forEach((button) => {
      //   button.addEventListener(
      //     'click',
      //     () => {
      //       this.announcementBarArrowButtonWasClicked = true;
      //     },
      //     { once: true }
      //   );
      // });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    // this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }


  /**
   * Returns an array of selected option value every time an option is changed
   * If the Color option is changed and the selected color not has the selected size option,
   * the first variant matching the selected color will used as fallback.
   */
  getSelectedOptionValues(target) {
    const isColorOption = target?.closest('fieldset')?.dataset?.type === 'color';

    if (target && isColorOption && target.dataset.size == "false") {
      return [target.dataset.optionValueId, target.dataset.firstVariant];
    }

    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked:not([data-no-size])")
    ).map(({ dataset }) => dataset.optionValueId);
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          target: event.target,
          type: event.target.closest('fieldset').dataset.type,
          selectedOptionValues: this.getSelectedOptionValues(event.target),
        },
      });
    });
  }
}

customElements.define('variant-selects', VariantSelects);

/**
 * Recently viewed products stored in localStorage.
 */
const RecentlyViewed = {
  STORAGE_KEY: 'montura_recently_viewed',

  /**
   * @param {string} handle Product handle.
   * @param {number} limit Max items to store.
   */
  addHandle(handle, limit) {
    if (!handle || !limit) return;

    const handles = this.getHandles().filter((h) => h !== handle);
    handles.unshift(handle);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(handles.slice(0, limit)));
  },

  /**
   * @returns {string[]}
   */
  getHandles() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored.filter((h) => typeof h === 'string' && h) : [];
    } catch {
      return [];
    }
  },

  /**
   * @param {number} limit
   * @param {string} [excludeHandle] Current product handle to exclude.
   * @returns {Array<{ handle: string }>}
   */
  getItems(limit, excludeHandle = '') {
    return this.getHandles()
      .filter((handle) => handle !== excludeHandle)
      .slice(0, limit)
      .map((handle) => ({ handle }));
  },
};

window.RecentlyViewed = RecentlyViewed;

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  get products() {
    return JSON.parse(this.dataset.products);
  }

  get limit() {
    return this.dataset.limit;
  }

  /**
   * @returns {'complementary' | 'substituting' | 'recently'}
   */
  get recommendationType() {
    const type = this.dataset.recommendationType;
    if (type === 'substituting' || type === 'recently') return type;
    return 'complementary';
  }

  get isRecentlyViewed() {
    return this.recommendationType === 'recently';
  }

  connectedCallback() {
    this.onResize = this.onResize || (() => this.handleCardsSize());
    window.removeEventListener('resize', this.onResize);
    window.addEventListener('resize', this.onResize);

    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.render();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
    this.observer?.disconnect();
  }

  async render() {
    let items;

    if (this.isRecentlyViewed) {
      const excludeHandle = this.dataset.currentProductHandle || '';
      items = window.RecentlyViewed.getItems(this.limit, excludeHandle);

      if (!items.length) {
        this.closest('.recommended-products__section-wrapper')?.classList.add('tw-hidden');
        return;
      }

      window.Shopify?.analytics?.publish('search_result', { items });
    } else {
      this.recommendationLabels = {
        complementary: ['PDP - Complementary'],
        substituting: ['PDP - Substituting'],
      };
      const labels = this.recommendationLabels[this.recommendationType] || this.recommendationLabels.complementary;

      const builder = new SearchRequestBuilder()
        .withProducts(this.products)
        .withAttributes(['name', 'handle', 'price', 'price_max', 'price_min', 'type', 'id'])
        .withLimit(this.limit)
        .withTracking(labels);

      const searchResponse = await fetch(
        this.recommendationType === 'substituting' ? builder.substituting() : builder.complementary()
      );
      const searchResponseJSON = await searchResponse.json();

      items = searchResponseJSON.product_data;

      SearchPage.publishRelated({
        products: this.products,
        limit: this.limit,
        recommendationType: this.recommendationType,
        items,
        labels,
      });
    }

    const sectionResponse = await fetch(SearchPage.getSectionRenderUrl(items, 'recommended'));
    const sectionResponseText = await sectionResponse.text();

    const html = new DOMParser().parseFromString(sectionResponseText, "text/html");
    this.querySelector('[data-swiper-wrapper]').innerHTML = html.querySelector('[result]').innerHTML;

    this.initProductSwiper();
    this.handleCardsSize();

    !this.isRecentlyViewed && SearchPage.trackClicks(
      this,
      (this.recommendationLabels?.[this.recommendationType] || this.recommendationLabels?.complementary)?.[0],
      this.recommendationType === 'substituting' ? 'recommendations/substituting' : 'recommendations/complementary'
    );
  }

  /**
   * Re-initializes Swiper after slides are injected (product-swiper runs too early on empty markup).
   */
  initProductSwiper() {
    const productSwiper = this.querySelector('product-swiper');
    const swiperContainer = this.querySelector('.swiper-container');
    if (!productSwiper || !swiperContainer) return;

    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }

    productSwiper.enableSwiper();
  }

  handleCardsSize() {
    const swiperWrapper = this.querySelector('[data-swiper-wrapper]');
    if (!swiperWrapper) return;

    swiperWrapper.style.removeProperty('--swiper-wrapper-height');
    const slideHeights = Array.from(this.querySelectorAll('.swiper-slide')).map(slide => slide.offsetHeight);
    const maxHeight = Math.max(...slideHeights);

    if (Number.isFinite(maxHeight) && maxHeight > 0) {
      swiperWrapper.style.setProperty('--swiper-wrapper-height', `${maxHeight}px`);
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('.trigger');
    this.descriptionButton = document.querySelector('.expandOnDescriptionTap');
    this.contentElement = this.querySelector('.js-read-more .js-read-more--text');
    this.blurElement = this.querySelector('.js-read-more--blur');
    this.escapeHtml = this.getAttribute('escape-html') || 'true';
    this.longContent = this.escapeHtml == 'true'
      ? this.contentElement.textContent
      : this.contentElement.innerHTML;
    this.enableReadLess = this.getAttribute('enable-read-less');
    this.charactersSubstring = this.getAttribute('data-truncate') || 90;

    // check for default open
    this.isDefaultOpen = this.dataset.isDefaultOpen === "true";
  }

  prepareShortContent() {
    this.shortContent = `${this.longContent.substring(0, this.charactersSubstring)}...`;
  }

  cutText() {
    this.contentElement.innerHTML = this.shortContent;
    this.setAttribute('data-content', 'short');
    this.classList.remove('tw-opacity-0');
    this.toggleButton.classList.remove('active');
  }

  connectedCallback() {
    if (this.longContent.length < this.charactersSubstring) {
      this.textShortEnough();
      return;
    }

    this.prepareShortContent();
    this.listener();

    if (this.isDefaultOpen) {
      this.expandText();
    } else {
      this.cutText();
    }
  }

  listener() {
    this.toggleButton.addEventListener("click", () => {
      this.toggleText();
    });

    if (this.descriptionButton) {
      this.descriptionButton.addEventListener("click", () => {
        this.expandText();
      });
    }
  }

  expandText() {
    this.contentElement.innerHTML = this.longContent;
    if (this.enableReadLess != "false") {
      if (this.blurElement) {
        this.blurElement.classList.add('tw-hidden');
      }
      this.toggleButton.innerText = this.toggleButton.getAttribute('text-less');
    }
    this.setAttribute('data-content', 'long');
    this.classList.remove('tw-opacity-0');
    this.toggleButton.classList.add('active');
  }

  toggleText() {
    if (this.dataset.content == 'long') {
      this.cutText();
      if (this.blurElement) {
        this.blurElement.classList.remove('tw-hidden');
      }
      this.toggleButton.innerText = this.toggleButton.getAttribute('text-more');
    } else {
      this.expandText();
    }
  }

  textShortEnough() {
    this.classList.remove('tw-opacity-0');

    if (this.blurElement) {
      this.blurElement.classList.add('tw-hidden');
    }

    this.toggleButton.classList.add('tw-hidden');
  }
}

customElements.define('read-more', ReadMore);



/**
 * Derived from ReadMore, it is used for parts where the read more must only be mobile
 */
class ReadMoreMobile extends ReadMore {
  constructor() {
    super();

    this.mobile = window.matchMedia("(max-width: 767px)").matches;
    this.resizeHandler();
  }

  connectedCallback() {
    if (this.mobile == true) {
      this.dataset.content == 'short'
      this.cutText();
    } else {
      this.toggleButton.classList.add('tw-hidden');
      this.classList.remove('tw-opacity-0');
    }
  }

  resizeHandler() {
    window.addEventListener('resize', () => {
      let mobile = window.matchMedia("(max-width: 767px)").matches;
      if (mobile == false && this.dataset.content == 'short') {
        this.contentElement.innerHTML = this.longContent;
        this.setAttribute('data-content', 'long');
      }
      if ((mobile == true && this.classList.contains('tw-initial-read-more'))) {
        this.classList.remove('tw-initial-read-more');
      }
    });
  }

}

customElements.define('read-more-mobile', ReadMoreMobile);

class AdaptiveSelect extends HTMLElement {
  constructor() {
    super();
    this.mainSelect = this.querySelector(".select__select")
    this.widthSelect = this.querySelector("#width_tmp_select");
    this.optionWidth = this.querySelector("#width_tmp_option");
  }

  connectedCallback() {
    // Ensure select is always keyboard accessible
    if (this.mainSelect) {
      this.mainSelect.classList.add('adaptive-select__control');
      this.mainSelect.setAttribute('tabindex', '0');
    }
    this.setSelectWidth();
    this.bindEvents();
  }

  setSelectWidth() {
    if (!this.mainSelect || !this.optionWidth || !this.widthSelect) return;
    
    const selectedIndex = this.mainSelect.selectedIndex;
    if (selectedIndex >= 0 && selectedIndex < this.mainSelect.options.length) {
      this.optionWidth.innerHTML = this.mainSelect.options[selectedIndex].innerText.trim();
      this.mainSelect.style.setProperty('--select-width', `${this.widthSelect.offsetWidth}px`);
    }
  }


  bindEvents() {
    if (this.mainSelect) {
      this.mainSelect.addEventListener("change", () => {
        this.setSelectWidth();
      });
    }
  }
}

customElements.define('adaptive-select', AdaptiveSelect);

class MorePaymentOptions extends HTMLElement {
  constructor() {
    super();
    this.morePaymentOptionBtn = this.querySelector('details');
    this.lessPaymentOptionBtn = this.querySelector('details .less-payment-option');
    // this.cartPaymentsWrapper = this.cartPaymentsContainer.firstChild;
  }

  connectedCallback() {
    this.eventListener();
    this.cartPaymentObserver();
  }

  cartPaymentObserver() {
    this.cartPaymentsContainer = this.querySelector(".dynamic-checkout__content");

    // Verifica che l'elemento esista prima di creare l'osservatore
    if (this.cartPaymentsContainer) {
      // Definisci la funzione di callback per l'osservatore
      const mutationCallback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // Il contenuto dell'elemento è cambiato
            this.cartPaymentWrapper = this.cartPaymentsContainer.querySelectorAll('.shopify-cleanslate')[1];
            this.cartPaymentElement = this.cartPaymentWrapper?.querySelectorAll('ul li');
            if (this.cartPaymentElement?.length >= 1) {
              this.morePaymentOptionBtn.classList.remove('hidden');
              publish(PUB_SUB_EVENTS.loadedPayments, '');
              break;
            } else {
              this.morePaymentOptionBtn.classList.add('hidden');
            }
          }
        }
      };
      const observer = new MutationObserver(mutationCallback);
      const observerOptions = {
        childList: true,
        subtree: true
      };
      observer.observe(this.cartPaymentsContainer, observerOptions);
    }
  }


  eventListener() {
    this.resize();
    if (window.innerWidth > 1024) {
      this.morePaymentOptionBtn.setAttribute('open', '');
    }
    // Add the resize event listener to the window object
    this.lessPaymentOptionBtn.addEventListener('click', () => {
      this.morePaymentOptionBtn.removeAttribute('open');
    })
  }
  resize() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        this.morePaymentOptionBtn.setAttribute('open', '');
      } else {
        // Optionally, close the button on smaller screens (if desired)
        this.morePaymentOptionBtn.removeAttribute('open');
      }
    })
  }
}

customElements.define('more-payment-options', MorePaymentOptions)

class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.detail = this.querySelector('details');
    this.summary = this.detail.querySelector('summary');
    this.content = this.detail.querySelector('.accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  }

  connectedCallback() {
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }
  onClick(e) {
    e.preventDefault();
    this.detail.classList.add('is-animating');
    if (this.isClosing || !this.detail.open) {
      this.open();
    } else if (this.isExpanding || this.detail.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.detail.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.detail.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Temporary measured height required to seed the WAAPI expand animation
    this.detail.style.height = `${this.detail.offsetHeight}px`;
    this.detail.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.detail.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.detail.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  onAnimationFinish(open) {
    this.detail.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.detail.classList.remove('is-animating');
    this.detail.style.removeProperty('height');
  }
}
customElements.define('custom-details', CustomAccordion);


class AnchorScroller extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('.js-scroller-element');

    if (this.scroller) {
      this.scroller.addEventListener("click", this.handleClick.bind(this));
    } else {
      console.warn("AnchorScroller: No `.js-scroller-element` element found inside.");
    }
  }

  handleClick(event) {
    event.preventDefault();

    const targetId = this.scroller.dataset.scrollToElement;
    if (!targetId) {
      console.warn("AnchorScroller: No `scroll-to-element` attribute specified.");
      return;
    }
    const targetElement = document.querySelector(`#${targetId}`);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn(`AnchorScroller: No element found with ID "${targetId}".`);
    }
  }
}

customElements.define('anchor-scroller', AnchorScroller);

(function initNewsletterPopup() {
  // Set the initial interval for displaying the newsletter popup (in milliseconds)
  const interval = 60000;

  // Retrieve the existing end time from localStorage, or reset it if not found
  const storedEndTime = localStorage.getItem('endTime');
  let endTime = storedEndTime ? parseInt(storedEndTime) : +new Date + interval;

  // Function to reset the end time for the next popup display
  // function resetEndTime() {
  //   endTime = +new Date + interval;
  //   localStorage.setItem('endTime', endTime.toString());
  // }

  // Main execution loop (setInterval)
  let intervalId;

  intervalId = setInterval(function () {
    const remainingTime = endTime - new Date();
    // ... rest of your code
    if (remainingTime <= 0) {
      publish(PUB_SUB_EVENTS.newsletterTimerEnded);
      clearInterval(intervalId); // Use the stored interval ID
    }
  }, 100);
  // Check every 100 milliseconds (adjust for desired precision)
})()


class ScrollToButton extends HTMLElement {
  constructor() {
    super();
    this.targetElementSelector = this.dataset.targetElementSelector || '';
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault()
      this.handleClick()
    });
  }

  handleClick() {
    if (!this.targetElementSelector) return;
    const target = document.querySelector(this.targetElementSelector);
    target.scrollIntoView({ block: "center", behavior: "smooth" })
  }
}

if (!customElements.get('scroll-to-button')) {
  customElements.define('scroll-to-button', ScrollToButton)
}

/**
 * Usage:
 * ```
 * <deferred-section data-handle="{{ product.handle }}" data-random="false" data-view="nameOfTheTemplateToRender"> </deferred-section> 
 * ```
 */
class DeferredSection extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.handle;
    this.view = this.dataset.view;
    this.random = this.dataset.random === 'true';
  }
  connectedCallback() {
    this.observe();
  }

  observe() {
    this.observer?.unobserve?.(this);
    this.observer = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting)
        return;
      observer.unobserve(this);
      this.render();
    }, { rootMargin: '0px 0px 400px 0px' });
    this.observer.observe(this);
  }

  async render() {
    const parameters = this.random 
      ? `?q=${new Date().toString()}&view=${this.view}` 
      : `?view=${this.view}`;

    const rootUrl = window.routes.root_url || ''
    const url = `${location.origin + rootUrl}/products/${this.productHandle}${parameters}`;

    const response = await fetch(url);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    this.innerHTML = html.querySelector('body').innerHTML;

    setTimeout(() => {
      if (this.view === 'high') {
        window.initPhotoSwipe(null, '[data-high-images-gallery]', 'a.pwsp-img');
      }
    }, 100);
  }
}
if (!customElements.get('deferred-section')) {
  customElements.define('deferred-section', DeferredSection)
}
class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.boundClickHandler = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('.video-container').forEach(container => {
      const video = container.querySelector('video');
      const btn = container.querySelector('.video-play-button');
      this.initVideo(video, btn);
    });

    // Event listener 
    this.addEventListener('click', this.boundClickHandler);
  }

  disconnectedCallback() {
    // Cleanup to avoid memory leaks
    this.removeEventListener('click', this.boundClickHandler);
  }

  handleClick(e) {
    const btn = e.target.closest('.video-play-button');
    if (!btn) return;

    const video = btn.closest('.video-container')?.querySelector('video');
    if (!video) return;

    this.toggleVideo(video, btn);
  }

  toggleVideo(video, btn) {
    if (video.paused) {
      video.play();
      this.setButtonState(btn, 'playing');
    } else {
      video.pause();
      this.setButtonState(btn, 'paused');
    }
  }

  setButtonState(btn, state) {
    const isPlaying = state === 'playing';

    // Toggle classes — icon visibility is owned by CSS (.playing / .paused)
    btn.classList.toggle('playing', isPlaying);
    btn.classList.toggle('paused', !isPlaying);
  }

  initVideo(video, btn) {
    if (!video || !btn) return;

    // set init status based on autoplay 
    this.setButtonState(btn, video.paused ? 'paused' : 'playing');

    // sync ui with video status 
    video.addEventListener('play', () => this.setButtonState(btn, 'playing'));
    video.addEventListener('pause', () => this.setButtonState(btn, 'paused'));
  }
}

// subsicrivbe component
if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer);
}

class ProductUtils {
  /*
   * FORM
   */

  static resetProductFormState(productForm) {
    this.toggleSubmitButton(productForm, false);
    productForm?.handleErrorMessage();
  }

  static toggleSoldOut(productForm) {
    this.toggleSubmitButton(productForm, true, window.variantStrings.soldOut);
  }

  static toggleUnavailable(productForm) {
    this.toggleSubmitButton(
      productForm,
      true,
      window.variantStrings.unavailable
    );
  }

  static toggleSubmitButton(productForm, isDisabled, string) {
    if (!productForm) return;
    productForm.toggleSubmitButton(isDisabled, string);
  }

  /*
   * VARIANTS
   */

  static getSelectedVariant(html) {
    if (!html) return;
    const selectedVariant = html.querySelector(
      "[data-selected-variant]"
    ).innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  static updateVariantInputs(element, variantId = "", options = {}) {
    if (!element) return;

    const defaultOptions = {
      selector: 'input[name="id"]',
      callback: null,
    };
    const selector = options.selector || defaultOptions.selector;
    const callback = options.callback || defaultOptions.callback;

    element
      .querySelectorAll(`[data-section-id='${element.dataset.section}'`)
      .forEach((productForm) => {
        const input = productForm.querySelector(selector);
        if (!input) return;
        input.value = variantId;
        if (typeof callback === "function") callback(input);
      });
  }

  static updateSource(element, html, section, updateAttributes = false) {
    const sources = html.querySelectorAll(section);
    const destinations = element.querySelectorAll(section);

    if (sources.lenght == destinations.lenght) {
      sources.forEach((source, index) => {
        destinations[index].innerHTML = source.innerHTML;
        if (updateAttributes) {
          for (let { name, value } of source.attributes)
            destinations[index].setAttribute(name, value);
        }
      });
    }
    else if (sources.lenght == 0) {
      destinations.forEach((destination) => {
        destination.innerHTML = '';
      });
    }
  }

  static buildRequestUrlWithParams(url, sectionId, optionValues) {
    const params = [];
    if (sectionId) {
      params.push(`section_id=${sectionId}`);
    }

    if (optionValues.length)
      params.push(`option_values=${optionValues.join(',')}`);

    return `${url}?${params.join('&')}`;
  }
}

if (!customElements.get('announcement-marquee')) {
  class AnnouncementMarquee extends HTMLElement {
    static DEFAULT_SPEED_PX = 0.5;
    static REBUILD_DEBOUNCE_MS = 100;
    static CLONE_ATTR = 'data-marquee-clone';
    static HOVER_MQ = '(hover: hover)';
    static TRACK_SELECTOR = '.announcement-marquee__track';
    static GROUP_SELECTOR = '.announcement-marquee__group';
    static TOGGLE_SELECTOR = '[data-announcement-marquee-toggle]';

    constructor() {
      super();
      this.speed = 0;
      this.offset = 0;
      this.groupWidth = 0;
      this.pausedByUser = false;
      this.pausedByHover = false;
      this.animationId = null;
      this.resizeObserver = null;
      this.rebuildHandler = null;
      this.track = null;
      this.group = null;
      this.cloneGroup = null;
      this.onMouseEnter = null;
      this.onMouseLeave = null;
      this.onDocumentClick = null;
    }

    connectedCallback() {
      this.speed = Number(this.dataset.speed) || AnnouncementMarquee.DEFAULT_SPEED_PX;
      this.track = this.querySelector(AnnouncementMarquee.TRACK_SELECTOR);
      this.group = this.querySelector(AnnouncementMarquee.GROUP_SELECTOR);
      if (!this.track || !this.group) return;

      this.rebuildHandler = this.debounce(() => this.rebuild(), AnnouncementMarquee.REBUILD_DEBOUNCE_MS);
      this.resizeObserver = new ResizeObserver(this.rebuildHandler);
      this.resizeObserver.observe(this);

      const canHover = window.matchMedia(AnnouncementMarquee.HOVER_MQ).matches;
      if (canHover) {
        this.onMouseEnter = () => { this.pausedByHover = true; };
        this.onMouseLeave = () => { this.pausedByHover = false; };
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
      }

      this.onDocumentClick = (event) => {
        const toggle = event.target.closest(AnnouncementMarquee.TOGGLE_SELECTOR);
        toggle && this.togglePause();
      };
      document.addEventListener('click', this.onDocumentClick);

      this.rebuild();
    }

    disconnectedCallback() {
      this.cancelAnimation();
      this.removeClone();
      this.resizeObserver && this.resizeObserver.disconnect();
      this.onMouseEnter && this.removeEventListener('mouseenter', this.onMouseEnter);
      this.onMouseLeave && this.removeEventListener('mouseleave', this.onMouseLeave);
      this.onDocumentClick && document.removeEventListener('click', this.onDocumentClick);
    }

    togglePause() {
      this.pausedByUser = !this.pausedByUser;
      const pressed = String(this.pausedByUser);
      const toggles = document.querySelectorAll(AnnouncementMarquee.TOGGLE_SELECTOR);
      for (const toggle of toggles) {
        toggle.setAttribute('aria-pressed', pressed);
        const label = this.pausedByUser ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
        label && toggle.setAttribute('aria-label', label);
      }
    }

    rebuild() {
      this.cancelAnimation();
      this.removeClone();

      const viewportWidth = this.clientWidth;
      if (!viewportWidth) return;

      this.group.style.removeProperty('--marquee-group-width');
      const naturalWidth = this.group.scrollWidth;
      this.groupWidth = Math.max(viewportWidth, naturalWidth);
      this.group.style.setProperty('--marquee-group-width', `${this.groupWidth + 200}px`);

      this.cloneGroup = this.group.cloneNode(true);
      this.cloneGroup.setAttribute(AnnouncementMarquee.CLONE_ATTR, '');
      this.cloneGroup.setAttribute('aria-hidden', 'true');
      this.track.appendChild(this.cloneGroup);

      this.offset = 0;
      this.startAnimation();
    }

    removeClone() {
      this.cloneGroup && this.cloneGroup.remove();
      this.cloneGroup = null;
      this.group && this.group.style.removeProperty('--marquee-group-width');
    }

    startAnimation() {
      const tick = () => {
        if (!this.pausedByUser && !this.pausedByHover) {
          this.offset += this.speed;
          this.offset >= this.groupWidth && (this.offset -= this.groupWidth);
        }
        this.track.style.setProperty('--marquee-offset', `${this.offset}px`);
        this.animationId = requestAnimationFrame(tick);
      };
      this.animationId = requestAnimationFrame(tick);
    }

    cancelAnimation() {
      this.animationId && cancelAnimationFrame(this.animationId);
      this.animationId = null;
      this.track && this.track.style.removeProperty('--marquee-offset');
    }

    debounce(callback, wait) {
      let timeoutId = null;
      return () => {
        timeoutId && clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, wait);
      };
    }
  }

  customElements.define('announcement-marquee', AnnouncementMarquee);
}